if (!process.env.REACT_APP_NO_HELPSCOUT && !process.env.REACT_APP_NO_EXTERNAL) {
  (function (e, t, n) {
    function a() {
      const j = t.getElementsByTagName("script")[0];
      const n = t.createElement("script");
      n.type = "text/javascript";
      n.async = !0;
      n.src = "https://beacon-v2.helpscout.net";
      j.parentNode?.insertBefore(n, j);
    }

    //
    if (
      ((e.Beacon = n =
        function (t: any, n: any, a: any) {
          e.Beacon.readyQueue.push({
            method: t,
            options: n,
            data: a,
          });
        }),
      (n.readyQueue = []),
      t.readyState === "complete")
    )
      return a();

    e.addEventListener
      ? e.addEventListener("load", a, !1)
      : (e as any).attachEvent("onload", a);
  })(window, document, window.Beacon || function () {});

  //
  window.Beacon("init", "010e90eb-8a4c-444f-8d5e-177125939a7a");
} else {
  console.info("HelpScout disabled");
}

// -----------------------------------------------------------------------------

export {};
